<template>
  <section class="display">
    <div class="pop-up-overlay" @click="servicePopup = false" v-if="servicePopup"></div>

    <div class="slider">
      <div class="slider__slide">
        <img class="slider__image" src="../assets/hero-image.jpg" alt="spray foam">
        <div class="slantRight" :style="{borderBottom: ' 50px solid #111'}"></div>
        <div class="overlay"></div>

        <img class="logo" src="../assets/lizard-logo.png" alt="Critchfield Spray Foam Logo">
        <br>
        <p>
          <vue-typer class="slider__typer" :text="typer" erase-style='clear'></vue-typer>
        </p>
        <a href="tel:7855568086"><button>Call Now</button></a>
      </div>
    </div>


    <section id="SprayFoam" class="page-section bg-black">

      <div class="slantRight" :style="{borderBottom: ' 50px solid #F38F00'}"></div>
      <div data-aos="fade-up" class="decor-right">
        <img  src="../assets/decor-02.png" alt="">
      </div>

      <div data-aos="fade-up" class="info">
        <h3>Why Spray Foam?</h3>
        <p>Why use spray foam instead of other conventional insulation? Spray foam insulates and air seals the building’s exterior in one application. Conventional insulation can’t say this.</p>
        <p >Spray foam insulation achieves a perfect fit every time eliminating voids and gaps between other building elements reducing air infiltration thus reducing energy loss. It doesn’t sag, settle or deteriorate like other conventional insulation.</p>
      </div>
    </section>

    <section id="Services" class="page-section bg-orange">
        <div class="slantRight" :style="{borderBottom: ' 50px solid #fff'}"></div>

      <div class="info" >
      <h3 data-aos="fade-up">Our Services</h3>
        <div>
          <p data-aos="fade-up">Spray foam is not only ideal for new residential, commercial and industrial construction but equally suited for all types of additions and open cavity remodels as well as pre-engineered metal buildings and machine sheds. Critchfield Sprayfoam also applies exterior damp proofing to concrete foundations and basements as well as roof coating systems. Click on our services below to gain a better idea of the services we provide!</p>
          <div class="service-parent">
            <div @click="one = !one" data-aos="fade-up"  class="service-child">
              <h3>Insulation</h3>
              <p>more information</p>
            </div>

            <div @click="two = !two" data-aos="fade-up" data-aos-delay="100" class="service-child">
              <h3>Concrete Lifting</h3>
              <p>more information</p>
            </div>   

            <div @click="three = !three" data-aos="fade-up" data-aos-delay="100" class="service-child">
              <h3>Soil Stabilization</h3>
              <p>more information</p>
            </div>    
          </div>
        </div>
      </div>
    </section>

      <section  class=" sm-section bg-white ">
        <div data-aos="fade-up" class="decor-right">
          <img  src="../assets/decor-02.png" alt="">
        </div>

        <div data-aos="fade-up" class="info">
          <h3>Do we service your area?</h3>
          <p>We’ve had the privilege of servicing hundreds of businesses and residential spots in the area. Let us help you with any Spray Foam, Concrete Lifting, Soil Stabilization, or Spray Foam Roofing at your business, or private residence as we service up to a 200 mile radius.</p>
          <p>Give us a call or email us today to get a quote on your service needs!</p>
        </div>

         <div class="divide">
           <div class="split">
              <div class="image-contain">
                <img class="image" src="../assets/truck.jpg" alt="spray foam">
              </div>
              <div class="image-contain map">
                <img class="image" src="../assets/map.png" alt="spray foam">
              </div>
            </div>
         </div>

         <div class="divide divide-half">

            <div class="half">
              <div class="info">
                <h3 data-aos="fade-up">Spray Foam Benefits</h3>
                <ul data-aos="fade-up" class="list">
                  <li>Adds structural stability</li>
                  <li>Provides a continuous air barrier</li>
                  <li>Prevents moisture infiltration</li>
                  <li>Superior energy savings</li>
                  <li>Minimizes insect and rodent penetration</li>
                </ul>
              </div>
            </div>

           <div class="half">
                <div class="image-contain">
                  <div class="fb-video" data-href="https://www.facebook.com/CritchfieldSprayfoamInsulation/videos/10151459723344123/?v=10151459723344123" data-full-width-responsive="true" data-show-text="false"><blockquote cite="https://developers.facebook.com/CritchfieldSprayfoamInsulation/videos/10151459723344123/" class="fb-xfbml-parse-ignore"><a href="https://developers.facebook.com/CritchfieldSprayfoamInsulation/videos/10151459723344123/"></a><p></p>Posted by <a href="https://www.facebook.com/CritchfieldSprayfoamInsulation/">Critchfield Sprayfoam Insulation</a> on Monday, April 1, 2013</blockquote></div>
                </div>
            </div>
         </div>

          <div class="payment">
            <img data-aos="fade-up" :data-aos-delay="idx + '00'" v-for="(display, idx) in payments" :key="idx" :src="display" alt="payment icon">
          </div>

          <p class="skinny" data-aos="fade-up">All sales final. 100% Guarantee!</p>

        <div class="slantRight" :style="{borderBottom: ' 50px solid #111'}"></div>

    </section>
    
    <section id="Contact" class="page-section bg-black flex">

      <div class="flex-align" data-aos="fade-up">
        <h2>Contact us</h2>
        <p><a href="tel:7853632057">785-363-2057</a> <br> <a href="tel:7855568086">785-556-8086</a></p>
        <p class="green">Go Green Today!</p>
        <p>Critchfield Sprayfoam Insulation <br>2086 4th Rd.<br>Waterville, KS 66548</p>
      <div class="footer-image" data-aos="fade-up" data-aos-delay="200">
        <img  src="../assets/foot.png" alt="footer image">
      </div>
      </div>
      <div  class="flex-align" data-aos="fade-up" data-aos-delay="300">

        <a href="mailto:critchfieldsprayfoam@yahoo.com">
          <button>
            Email Now
          </button>
        </a>
        <p>
        Or mail us directly at
        <a href="mailto:critchfieldsprayfoam@yahoo.com">
          critchfieldsprayfoam@yahoo.com
        </a>
        </p>

      </div>
      <div class="flex-align" data-aos="fade-up">
        <h2>More info</h2>
        <p class="green"><a href="http://ncfi.com/insulation/products/insulbloc/">NCFI.com</a></p>
      </div>
      <div class="flex-align" data-aos="fade-up">
      </div>

      <span class="copyright">
        © Copyright 2020 Critchfield Spray Foam
      </span>
    </section>


    <!-- pop up components -->

    <div class="pop-up" :class="{'pop-up-active': servicePopup}">
      <div class="exit" @click="servicePopup = false" :class="{'pop-up-active': servicePopup}">x</div>

      <div class="pop-up-child" v-if="one">
        <div class="pop-up-child__section">
          <img src="../assets/media/sp1.jpg" alt="">
          <img src="../assets/media/sp2.jpg" alt="">
          <img src="../assets/media/sp3.jpg" alt="">
          <img src="../assets/media/sp4.jpg" alt="">
          <img src="../assets/media/sp5.jpg" alt="">
          <img src="../assets/media/sp6.jpg" alt="">
        </div>
        <div class="pop-up-child__section">
          <h3>Insulation</h3>
          <p>Sprayfoam is an excellent, efficient option for insulation. The polyurethane foam is applied as a liquid and rapidly expands to seal any cracks or voids. Closed cell foam is rigid and has an r-value of approximately 7 per inch, which may not sound impressive but when coupled with its air, vapor and moisture barrier properties, makes it far superior to other types of insulation. Open cell foam is much less dense, has an r-value of 3.5 per inch. It does not act as a vapor or moisture barrier, but makes a great air barrier and dampens sound. When it comes to most insulation needs, sprayfoam is the answer.</p>
          <a href="tel:7855568086"><button>Call Now</button></a>
        </div>
      </div>

      <div class="pop-up-child" v-if="two">
        <div class="pop-up-child__section">
          <img src="../assets/media/c-lifting.jpg" alt="">
          <img src="../assets/media/c-lifting-2.jpg" alt="">
        </div>
        <div class="pop-up-child__section">
          <h3>Concrete Lifting</h3>
          <p>When concrete slabs or even some structures are sinking, lifting foam and deep foam injection are great alternatives to mud jacking or costly repairs. Our lifting foam is injected under the slab through port drilled through the surface. This high density foam expands and lifts the slab to it's original position. Deep foam injection is applied through a rod driven in the ground and is used to stabilize the footings and surrounding soil of sinking stuctures.</p>
          <a href="tel:7855568086"><button>Call Now</button></a>
        </div>
      </div>

      <div class="pop-up-child" v-if="three">

        <div class="pop-up-child__section"></div>
        <div class="pop-up-child__section">
          <h3>Soil Stabiliaztion</h3>
          <p>Polyurethane works as a great soil stabilizer. Foam is sprayed into the ground where it fills any cracks and crevices then begins the expansion and hardening process. This results in a safer and more efficient soil stabilization procedure.</p>
          <a href="tel:7855568086"><button>Call Now</button></a>
        </div>
        </div>


    </div>




  </section>

</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'heroSection',
  data () {
    return {
      servicePopup: false,
      one: false,
      two: false,
      three: false,
      four: false,
      slideshow: {

        1: {
          id: 1,
          img: '../assets/sp1.jpg',
          left: 0,
          active: true },
        2: {
          id: 2,
          img: '../assets/sp2.jpg',
          left: '50vw',
          active: true }
          ,
        3: {
          id: 3,
          img: '../assets/sp3.jpg',
          left: '50vw',
          active: true }
          ,
        4: {
          id: 4,
          img: '../assets/sp4.jpg',
          left: '50vw',
          active: true }
          ,
        5: {
          id: 5,
          img: '../assets/sp5.jpg',
          left: '50vw',
          active: true }
          ,
        6: {
          id: 6,
          img: '../assets/sp6.jpg',
          left: '50vw',
          active: true }
      },
      benifits: false,
      benifitData: [
        'Adds structural stability',
        'Provides a continuous air barrier',
        'Prevents moisture infiltration',
        'Superior energy savings',
        'Minimizes insect and rodent penetration'
      ],
      typer: [
          "Licensed Applicator",
          "Over 30 Years Construction Experience",
          "Family Owned Business"
      ],
      whySprayFoam: false,
      title: null,
      button: null,
      link: null,
      alt: null,
      image: '',
      slideId: '',
      heroSection: [],
      payments: {
        1: require('../assets/payment-icon-01.png'),
        2: require('../assets/payment-icon-04.png'),
        3: require('../assets/payment-icon-05.png'),
        4: require('../assets/payment-icons-06.png'),
      },
      services: {
        concrete: {
          name: 'Concrete Lifting',
          desc: 'Spray foam insulation achieves a perfect fit every time eliminating voids and gaps between other building elements reducing air infiltration thus reducing energy loss. It doesn’t sag, settle or deteriorate like other conventional insulation.'
        },
        sprayFoam: {
          name: 'Spray Foam',
          desc: 'Spray foam insulation achieves a perfect fit every time eliminating voids and gaps between other building elements reducing air infiltration thus reducing energy loss. It doesn’t sag, settle or deteriorate like other conventional insulation.'
        },
        Soil: {
          name: 'Soil Stablization',
          desc: 'Spray foam insulation achieves a perfect fit every time eliminating voids and gaps between other building elements reducing air infiltration thus reducing energy loss. It doesn’t sag, settle or deteriorate like other conventional insulation.'
        },
        Roof: {
          name: 'Spray Foam Roofing',
          desc: 'Spray foam insulation achieves a perfect fit every time eliminating voids and gaps between other building elements reducing air infiltration thus reducing energy loss. It doesn’t sag, settle or deteriorate like other conventional insulation.'
        }
      },
      editData: [],
      errors: [],
      showNav: false,
      editClicked: false,
      form: {
        name: null,
        email: null,
        message: null
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
     this.txt = `it changed to ${newHeight} from ${oldHeight}`;
    },
    slideshow(val) {
      alert(val)
    },
    one(val) {
      this.servicePopup = val
    },
    two(val) {
      this.servicePopup = val
    },
    three(val) {
      this.servicePopup = val
    },
    four(val) {
      this.servicePopup = val
    },
    servicePopup(val) {
      val == false
      ? { one: this.one = false, two: this.two = false, three: this.three = false, four: this.four = false} 
      : null
    }
  },
  mounted() {
    window.addEventListener("hashchange", function () {
    window.scrollTo(window.scrollX, window.scrollY - 60);
    })
    this.$nextTick(() => {
      window.addEventListener('scroll', () => {
        this.windowHeight = window.pageYOffset

        window.pageYOffset >= 70 
        ? this.$parent.headerColor = '#111'
        : this.$parent.headerColor = 'rgba(0, 0, 0, 0.2)'
      });
    })
  },
  components: {
    // Carousel,
    // Slide
  },
  computed: {
    ...mapGetters([
      'activeForm'
    ])
  },
  methods: {
    sendForm(payload) {
      this.$store.dispatch('SEND_FORM', payload)
    }
  }
}
</script>

<style lang="scss" scoped>

  $break-small: 900px;


  .copyright {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    padding: 0 0 20px 0;
    font-size: 12px;
    letter-spacing: 1px;
    color: #777;
  }

  .skinny {
    padding: 0;
    margin: 0;
  }

    .green {
      color: #3b9549;
    }

    .list {
      list-style: none;
      margin: 0;
      padding: 0;
      li {
        position: relative;
        // border-left: 1px solid black;
        margin: 0;
        padding: 0 0 10px 30px;
        &:not(:last-child) {
          &::before {
            content: "";
            position: absolute;
            height: 100%;
            width: 1px;
            background-color: #3b9549;
            top: 10px;
            left: 0;
          }
        }
        &::after {
          content: "";
          position: absolute;
          left: 0;
          top: 10px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          border: 1px solid #3b9549;
          background-color: #fff;
          left: -10px;
          background-image: url('../assets/checkmark.svg');
          background-size: 12px;
          background-position: center;
          background-repeat: no-repeat;
        }
        &:last-child {
          border-left: none;
        }
      }
    }

    .exit {
      opacity: 0;
      pointer-events: none;
      z-index: 99999999999;
      background-color: #111;
      border: 1px solid #aaa;
      color: #fff;
      width: 40px;
      height: 40px;
      position: fixed;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 1px;
      font-size: 14px;
      cursor: pointer;
      transition: .3s all cubic-bezier(0.075, 0.82, 0.165, 1);
      @media screen and (max-width: $break-small) {
        position: fixed;
        margin-right: unset;
      }
    }
      .pop-up-active {
        opacity: 1;
        pointer-events: unset;
        transform: scale(1);
      }

  @keyframes shadow-pulse
  {
    0% {
        box-shadow: 0 0 0 0px rgba(59, 149, 73, 0.3);
        filter: blur(0)
    }
    15% {
        filter: blur(0.25px)
    }
    100% {
        box-shadow: 0 0 0 500px rgba(59, 149, 73, 0);
        filter: blur(0)

    }
  }

  @keyframes scale-map
  {
    0% {
      transform:scale(1)
    }
    75% {
      transform:scale(1.2)
    }
    100% {
      transform:scale(1)
    }
  }

  .map {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      overflow: hidden;


      &::before {
        animation: shadow-pulse 5s infinite cubic-bezier(.3, 0.82, 0.165, .8);
        content: "";
        position: absolute;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 1px solid #F38F00;
      }


      &::after {
        content: "";
        position: absolute;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: #F38F00;
      }
  }

  .divide {
    width: 100%;
    max-width: 1000px;
    display: flex;
    height: inherit;
    margin: 5px 0;
    flex-direction: column;
        @media screen and (max-width: $break-small) {
        flex-flow: wrap;
         width: 100%;
       }

    h2 {
      font-size: 2em;
      font-style: italic;
      font-weight: bolder;
      // color: green;
    }

    .half {
      width: 90%;
      height: auto;
      margin: 0 auto;
      border-radius: 10px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;



       @media screen and (max-width: $break-small) {
        flex-flow: wrap;
         width: 90%;
         margin: 1em auto;
       }
      
      .image-contain {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

      }
      .image {
        width: 100%;
        height: auto;
        // object-fit: cover;
        bottom: 0;
        margin: 0;
        align-self: unset;
        justify-self: unset;
      }
    }
    
    .split {
      width: 80%;
      height: auto;
      margin: 0 auto;
      border-radius: 10px;
      overflow: hidden;
      box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 24px 0px;

      .image-contain {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

      }
      .image {
        width: 100%;
        height: auto;
        // object-fit: cover;
        bottom: 0;
        margin: 0;
        align-self: unset;
        justify-self: unset;
      }
    }
  }

  .divide-half {
    flex-direction: row;

    .image-contain {

    }
    .image {
      box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 24px 0px;
      border-radius: 10px;
      overflow: hidden;

    }
  }

  .footer-image {
      position: relative;
      width: 100%;
      left: 0;
      bottom: 0;
      margin: 2em auto 0 auto;
      text-align: left;
      img {
        width: 80%;
      }
    }

   .mobile-grid {
     display: flex;
     flex-direction: row;
     flex-flow: wrap;
     width: 100%;
     .mobile-photo {
       width: 90%;
       margin: 0 auto;
       img {
         width: 100%;
       }
     }
   }

  .service-parent {
    width: 98%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 2em 0;
    margin: 0 auto;

    .service-child {
      width: 20em;
      height: 20em;
      display: flex;
      margin: 0 5px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: 2px solid #fff;
      border-radius: 0;
      position: relative;
      cursor: pointer;

      &:hover{
        border-color: #fff;
        color: #F38F00;
      }
      &:before {
        content: "";
        position: absolute;
        width: 0%;
        height: 100%;
        left: 0;
        top: 0;
        transition: all .3s ease-in-out;
        z-index: -1;
        cursor: pointer;
      }
      &:hover:before {
        width: 100%;
        background-color: #fff;
      }


      h3 {
        font-size: 1.2vw;
      }
      p {
        font-size: 10px;
        margin: 0 auto;
      }
      
    }



    @media screen and (max-width: $break-small) {
        width: 98%;
        display: flex;
        flex-direction: row;
        flex-flow: wrap;
        padding: 0;


        .service-child {
          width: 60vw;
          height: 35vw;
          display: flex;
          margin: 2vw auto;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          h3 {
            font-size: 4vw;
            text-align: center;
          }
          p {
            font-size: 10px;
            margin: 0 auto;
          }
        }


    }
  }

  .service-icon {
    width: 100px;
    height: 100px;
    background-color: #eee;
    border-radius: 50%;
    cursor: pointer;
    transition: all .3s ease-in-out;
    transform: scale(1);
  }
  .service-icon:hover {
    background-color: #e9e9e9;
    transform: scale(1.2);
  }

  .slantRight {
    position: absolute;
    content: "";
    border-left: 100vw solid transparent;
    height: 0;
    width: 0;
    bottom: -1px;
    left: 0;
    z-index: 2;
}

  .slantLeft {
    position: absolute;
    content: "";
    border-left: 100vw solid transparent;
    height: 0;
    width: 0;
    top: -1px;
    left: 0;
    z-index: 2;
}

  .flex {
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
  }
  .flex-align {
    width: 45%;
    margin: 1em auto;
    line-height: 1em;
    display: flex;
    flex-flow: column;
    align-items: left;
    text-align: left;
    font-size: 20px;
    color: #ddd;

    h2 {
      text-transform: uppercase;
      font-size: 24px;
    }

    input, textarea {
      padding: 1em;
      background-color: rgb(30, 30, 30);
      border: none;
      outline: none;
      color: #eee;
      font-size: 18px;
      margin: 10px 0;
    }
    p {
      margin: 1em 0;
      line-height: 1.2em;
    }
  button {
    font-size: 16px;
    padding: 1em;
    width: 50%;
    margin: 3em auto 0 auto;
    background-color: unset;
    color: #fff;
    font-weight: 700;
    font-family: 'avenir', sans-serif;
    letter-spacing: 1px;
    font-style: italic;
    text-transform: uppercase;
    position: relative;
    z-index: 1;
    border: 2px solid #fff;
    border-radius: 50px;
    z-index: 1;
    overflow: hidden;
    outline: none;

    &:hover{
      border-color: #F38F00;
    }
    &:before {
      content: "";
      position: absolute;
      width: 0%;
      height: 100%;
      left: 0;
      top: 0;
      transition: all .2s ease-in-out;
      z-index: -1;
      cursor: pointer;
    }
    &:hover:before {
      width: 100%;
      background-color: #F38F00;
    }

  }
      @media screen and (max-width: $break-small) {
        width: 90% !important;
      }
    /* background-color: red; */
  }


  .slide h2 {
    font-family: 'didot', serif;
    letter-spacing: .2em;
    text-transform: uppercase;
    font-weight: lighter;
  }




.overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  z-index: 1;
  background-image: url('../assets/icons/pattern.png');
  background-size: 5px;
  background-repeat: repeat;
  background-color: rgba(0, 0, 0, 0.35);
}


.slide h2 {
  font-size: 4em;
  padding: 2em 0 0 0;
  width: 50%;
  margin: 0 0 20px 100px;
  text-align: left;
  position: relative;
  color: #fff;
  z-index: 1;
}



.info button {
  margin-top: 8px;
  margin-right: 5px;
  width: 22%;
  height: 3vw;
  font-size: 14px;
  border: none;
  border-radius: 20px;
  font-weight: 300;
  letter-spacing: 1px;
  outline: none;
  transition: 0.15s all ease-in-out;
      outline: none;

}

.info button:hover {
  background-color: black;
  color:  #c1e529;
}

.push-up {
  margin-top: -35px;
}

.icon-nav {
  position: absolute;
  width: 80%;
  height: auto;
  top: 620px;
  left: 50%;
  margin-left: -40%;
  z-index: 2;
}
.page-section {
  width: 100%;
  padding: 1em 0 80px 0;
  position: relative;
  height: auto;
}
.sm-section {
  width: 100%;
  height: inherit;
  position: relative;
  padding: 2em 0 4em 0;
  display: flex;
  flex-flow: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 100;

  .payment {
    width: 100vw;
    height: inherit;
    padding: 2em 0;
    img {
      width: 12%;
    } 
  }

  @media screen and (max-width: $break-small) {
    .payment {
      width: 60%;
      height: inherit;
      padding: 2em 0;
      img {
        width: 50%;
      }
    }
  }
}

.bg-black {
  background-color: #111;
  color: white;
}
.bg-white {
  background-color: #fff;
  color: #111;
}
.bg-orange {
  color: white;
  position: relative;
  background-color: #F38F00;
  width: 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  z-index: 100;
}
/* .bg-orange::before {
  content: '';
  position: absolute;
  top: -40px;
  background-image: url('../assets/spray-foam-bg.svg');
  left: 0;
  width: 100%;
  background-repeat: no-repeat;
  height: 100%;
  z-index: 1000;
  pointer-events: none;
} */

/* .bg-orange::after {
  content: '';
  position: absolute;
  bottom: -340px;
  background-image: url('../assets/spray-foam-bg-2.svg');
  left: 0;
  width: 100%;
  background-repeat: no-repeat;
  height: 100%;
  z-index: 2000;
  pointer-events: none;

} */

.border-left {
  padding: 0 0 5px 2em;
  border-left: 3px solid #fff;
}
.service {
  background-color: #ddd;
  border-radius: 30px;
  height: auto;
  margin-right: 10px;
  padding: 1em 1em;
}
.service h4 {
  font-family: 'Roboto Slab', 'Avenir', sans-serif;
  font-size: 1.1em;
}
.service p {
  font-family: 'Avenir', sans-serif;
  font-size: 0.8em;
}

@media only screen and (max-width: 900px) {

  .hide-mobile {
    display: none;
  }

  .slider {
    height: 600px !important;
  }

  .slide {
    height: 600px;
    background-size: cover;
    background-position: center;
    // -webkit-transform: translate3d(0,0,0) !important;
  }


  .info button {
      margin-top: 10px;
      margin-right: 5px;
      width: 70%;
      height: 10vw;
      font-size: 14px;
      border: none;
      border-radius: 20px;
      font-weight: 700;
  }



}
</style>

<style lang="scss">
  $break-small: 900px;

  @mixin transition {
  @for $i from 1 through 5 {
    &:nth-child(#{$i}) {
      transition: all .3s #{$i * .1}s ease-in-out;
    }
  }
}

  .decor-right, .decor-left {
    position: absolute;
    top: 0;
    img {
      width: 150px;
    }
      @media screen and (max-width: $break-small) {
        img{
          width: 50px;
        }
      }
  }
  
  .decor-right {
    right: 2em;
  }

  .decor-left {
    right: 2em;
  }

  .slider {
    background-color: #111;
    height: 800px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 15%;

    &__slide {
      height: 800px;
      width: 100%;
      background-size: cover;
      background-position: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;
    }
  &__image {
      position: absolute;
      width: 100%;
      height: inherit;
      object-fit: cover;
      bottom: 0;
      margin: 0;
      align-self: unset;
      justify-self: unset;
  }
  &__slide h2 {
    font-size: 2.4em;
    width: 90%;
    margin: 0 auto 0 auto;
    text-align: left;
    font-weight: 900;
  }
  &__slide .logo {
    position: relative;
    z-index: 1;
    margin: -1em auto 1em auto;
    width: 550px;
  }
  &__slide p {
    color: #fff;
    margin: 0; 
    margin: 0 auto 2em auto;
    font-size: 1.7em;
    position: relative;
    z-index: 1;
  }

  &__slide button {
    font-size: 1.1em;
    padding: 1em 3em;
    width: auto;
    background-color: unset;
    color: #fff;
    font-weight: 700;
    font-family: 'avenir', sans-serif;
    letter-spacing: 1px;
    font-style: italic;
    text-transform: uppercase;
    position: relative;
    z-index: 1;
    border: 2px solid #fff;
    border-radius: 50px;
    z-index: 1;
    overflow: hidden;
    outline: none;


    &:hover{
      border-color: #F38F00;
    }
    &:before {
      content: "";
      position: absolute;
      width: 0%;
      height: 100%;
      left: 0;
      top: 0;
      transition: all .2s ease-in-out;
      z-index: -1;
      cursor: pointer;
    }
    &:hover:before {
      width: 100%;
      background-color: #F38F00;
    }


  }



  .location {
    z-index: 5;
    display: flex;
    flex-direction: row;
    align-items: left;
    justify-content: left;
    padding: 5px;
    height: 60px;

      h3 {
        color: #fff;
        margin: 0;
        width: 80%;
      }
      img {
        width: 20%;
        max-width: 30px;
      }
    }


  @media screen and (max-width: $break-small) {
    &__slide {
      height: 600px;
      background-size: cover;
      background-position: center;
      -webkit-transform: translate3d(0,0,0) !important;

      .logo {    
        margin: 1em auto 0 auto;
        width: 90%;
      }

      p {
        color: #fff;
        margin: 0; 
        margin: 0 auto 2em auto;
        font-size: 1.2em;
        position: relative;
        z-index: 1;
      }
    }

  }
  }

  .slideshow {
    width: 100%;
    overflow-x: scroll;
    background-color: #111;
    bottom: 0;
    height: 12vh;
    position: absolute;
    z-index: 99999;
    display: flex;
    flex-direction: row;
    justify-content: center;
    img {
      height: calc(12vh - 2px);
      border-right: 1px solid #fff;
      border-left: 1px solid #fff;

      width: auto;
    }
  }

  .pop-up-overlay {
    z-index: 99999;
    background-color: rgba(17, 17, 17, 0.562);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .pop-up {
    opacity: 0;
    pointer-events: none;
    transition: .3s all ease-in-out;
    transform: scale(.9);
    position: fixed;
    top: 95px;
    right: 30px;
    bottom: 50px;
    left: 30px;
    color: #111;
    background-color: rgba(255, 255, 255, 1);
    max-width: 1000px;
    margin: 0 auto;
    display: flex;
    -webkit-overflow-scrolling: touch;
    z-index: 1000000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 100px;
    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 24px 0px;
    overflow: hidden;
    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 24px 0px;
    a {
      text-align: center;
    button {
      font-size: 16px;
      padding: 1em;
      width: 50%;
      margin: 50px auto;
      background-color: unset;
      color: #000;
      font-weight: 700;
      font-family: 'avenir', sans-serif;
      letter-spacing: 1px;
      font-style: italic;
      text-transform: uppercase;
      position: relative;
      z-index: 1;
      border: 2px solid #000;
      border-radius: 50px;
      z-index: 1;
      overflow: hidden;
      outline: none;

      &:hover{
        border-color: #F38F00;
        color: #fff;
      }
      &:before {
        content: "";
        position: absolute;
        width: 0%;
        height: 100%;
        left: 0;
        top: 0;
        transition: all .2s ease-in-out;
        z-index: -1;
        cursor: pointer;
      }
      &:hover:before {
        width: 100%;
        background-color: #F38F00;
      }
    }
    }

      @media screen and (max-width: $break-small) {
        max-width: unset;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
      }

    .pop-up-child {
      width: 100%;
      height: 100%;
      position: absolute;
      overflow-y: scroll;
      display: flex;
      flex-direction: row;
      flex-flow: wrap;
      top: 0;
      left: 0;
      z-index: 1;
      padding-bottom: 100px;

      &::-webkit-scrollbar { width: 0 !important }

      &__section {
        width: 50%;
        text-align: left;
        display: flex;
        flex-direction: column;

        &::-webkit-scrollbar { width: 0 !important }

        img {
          margin: 10px auto;
          width: 95%;
        }
        h3 {
          width: 90%;
          margin: 2em auto 25px auto;
        }
        p {
          margin: 0 auto;
          width: 90%;
        }
        @media screen and (max-width: $break-small) {
            width: 90%;
            margin: 0 auto;
        }
      }


      @media screen and (max-width: $break-small) {
        position: relative;
        flex-direction: row;
        background-color: #fff;
        padding: 80px 0;
      }

    }



    h3 {  font-family: 'Roboto Slab', 'Avenir', sans-serif;
          font-size: 2em;
      }
    li {
      text-align: left;
      font-size: 1.4em;
      @include transition;
    }
    p {
      text-align: left;
      font-size: 1em;
      max-width: 100%;
      margin: 0 auto;
    }

  

  }

      .pop-up-active {
        opacity: 1;
        pointer-events: unset;
        transform: scale(1);
      }

  .vue-typer {
  /* Styles for the vue-typer container
     e.g. font-family, font-size  */
 
  .custom.char {
    /* Styles for each character
       e.g. color, background-color */
 
    &.typed {
      color: #fff !important;
      margin: 0; 
      margin: 0 auto 0 auto;
      font-family: 'Roboto Slab', 'Avenir', sans-serif;
      font-size: 0.8em;
      font-weight: 500;
      position: relative;
      z-index: 1;
    }

  }
  .custom.caret {
    background-color: #fff;
    margin-left: 2px;
  }
  }




</style>
